import axios from "@/js/project-axios.js";

const list = (name, servicerName) => {
    let params;
    if (typeof name == "object" && !servicerName) {
        params = name
    } else {
        params = {
            name,
            servicerName
        };
    }
    return axios.get("/admin/app/list", {
        params
    });
};

const approve = approve => {
    return axios.post("/admin/app/approve", approve);
};

export default {
    list,
    approve
};